import classnames from 'classnames';
import { forwardRef } from 'react';

import styles from './TableHead.module.scss';
import { TableHeadProps } from './TableHead.types';

export const TableHead = forwardRef<HTMLDivElement, TableHeadProps>(
  ({ pinned, pinDistance, style, className, ...props }, ref) => (
    <div
      ref={ref}
      className={classnames(styles.container, className, pinned && styles[pinned])}
      style={{
        ...style,
        // @ts-expect-error ---
        ['--pin-distance']: (pinDistance ?? 0) + 'px',
      }}
      data-role="th"
      {...props}
    />
  )
);
